import ActGuildAllStar from '@/assets/jce/ActGuildAllStarServant.js';
import './wsChannel';
import { fetchProd, getURLParam } from '@tools/func.ts';
import { data } from './data.js';
declare global {
  interface Window {
    Taf: any
  }
}
const staticClose = false;
const Taf = window.Taf || null;
const callWup: (moduleName: string, funcName: string, data: any, unpackFun: any) => Promise<any> = (moduleName, funcName, data, unpackFun) => {
  const TestURL = 'http://testws.va.huya.com?timestamp=';
  const ProdURL = 'https://cdnws.api.huya.com?timestamp=';
  const URL = fetchProd() ? ProdURL : TestURL;
  const wup = new Taf.Wup();
  wup.setServant(moduleName);
  wup.setFunc(funcName);
  wup.writeStruct('tReq', data);
  const buffer = wup.encode().getBuffer();
  const timestamp = new Date().getTime();
  return new Promise((resolve, reject) => {
    Taf.Util.ajax(URL + timestamp,
      buffer,
      (value: any) => {
        const rsp = new Taf.Wup();
        rsp.decode(value);
        const result = new unpackFun();
        rsp.readStruct('tRsp', result, unpackFun);
        // console.log(funcName, JSON.stringify(result));
        resolve(result);
      },
      (res: any) => {
        reject(res);
      });
  })
}
const tafFetch = (moduleName: string, data: any, requ: any, resp: any) => {
  const req = requ === null ? null : new requ();
  Object.keys(data).forEach(key => {
    req[key] = data[key];
  })
  return callWup('wupui', moduleName, req, resp);
}

const random = (min: number, max: number) => {
  return Math.floor(Math.random() * (max - min)) + min;
}
const RankItemMock: (count: number) => RankItem[] = count => {
  let data = [];
  for (let i = 0; i < count; i++) {
    let lUid = random(9999999, 100000);
    data.push({
      lUid,
      iRank: i + 1,       // 排名
      lScore: random(0, 99999999),      // 分数
      sNickName: random(0, count) + '随机昵称随机昵称',   // 昵称
      sLogoUrl: '',    // 头像
      tJump: {
        lPid: lUid,       // 主播Uid
        lTid: 0,          // 频道Tid
        lSid: 0,          // 频道Sid
        iGameId: 0,       // 品类id
        lYYId: 0,         // YY
        iRoomId: random(0, 99999),    // roomid
        iLive: random(0, 99999999) % 2 === 0 ? 0 : 1,      // 是否在播
      },
      iPromoteStatus: 0,
      sDesc: '娱乐全明星活动期间，tab默认定位在五大国民偶像上，五大国民偶像和最强交友天团都可以打开娱乐全明星活动期间，tab默认定位在五大国民偶像上，五大国民偶像和最强交友天团都可以打开',
      iStarIdol: 0,
      sPortraitUrl: '',
    })
  }
  data = data.sort((prev, next) => next.lScore - prev.lScore);
  for (let i = 0; i < count; i++) {
    data[i].iRank = i + 1;
  }
  return data;
}

const HourTopItemMock: (count: number) => HourTopItem[] = count => {
  let data = [];
  for (let i = 0; i < count; i++) {
    let lUid = random(9999999, 100000)
    data.push({
      sNickName: random(0, count) + '随机昵称随机昵称',   // 昵称
      sLogoUrl: '',    // 头像
      sDesc: '随机描述' + random(0, count),
      tJump: {
        lPid: lUid,       // 主播Uid
        lTid: 0,          // 频道Tid
        lSid: 0,          // 频道Sid
        iGameId: 0,       // 品类id
        lYYId: 0,         // YY
        iRoomId: random(0, 99999),    // roomid
        iLive: random(0, 99999999) % 2 === 0 ? 0 : 1,      // 是否在播
      },
    })
  }
  return data;
}

const GuildItemMock: (count: number) => GuildItem[] = count => {
  let data = [];
  for (let i = 0; i < count; i++) {
    data.push({
      iRank: i + 1,
      lScore: random(0, 99999999),      // 分数,
      lCompanyId: random(0, 99999999),
      sCompanyLogoUrl: '',    // 头像
      sCompanyName: '随机描述' + random(0, count),
      sDesc: random(0, 99999999) % 2 === 0 ? '' : '公会描述啊公会描述啊公会描述啊公会描述啊公会描述啊',
      vRank: {
        value: RankItemMock(20),
      },
    })
  }
  return data;
}

const GuildPkRoundItemMock: (count: number) => GuildPkRoundItem[] = count => {
  let data: GuildPkRoundItem[] = [];
  for (let i = 0; i < count; i++) {
    data.push({
      sAttGuildName: random(0, count) + '攻击方公会名',
      sAttGuildLogo: '',
      sDefGuildName: random(0, count) + '防守方公会名',
      sDefGuildLogo: '',
      iAttWin: random(0, 10),
      iDefWin: random(0, 10),
      vMatch: {
        value: [
          {
            tAttSide: RankItemMock(1)[0],
            tDefSide: RankItemMock(1)[0],
            iMatch: 1,
            iResult: random(1, 2),
            sDesc: '已结束',
            iStatus: 2,
          },
          {
            tAttSide: RankItemMock(1)[0],
            tDefSide: RankItemMock(1)[0],
            iMatch: 2,
            iResult: 0,
            sDesc: '进行中',
            iStatus: 1,
          },
          {
            tAttSide: RankItemMock(1)[0],
            tDefSide: RankItemMock(1)[0],
            iMatch: 3,
            iResult: 0,
            sDesc: random(10, 20) + ':00',
            iStatus: 0,
          },
        ],
      },
    })
  }
  return data;
}

/*
   enum RankAreaURI
    {
        kGame           = 1,     // 巅峰公会赛:游戏, 公会全明星:端游
        kEntertainment  = 2,     // 巅峰公会赛:娱乐, 公会全明星:综合娱乐
        kMobileGame     = 3,     // 手游
        kStar           = 4,     // 星秀
        kFace           = 5,     // 颜值
        kGold           = 6,     // 金牌公会(巅峰公会赛决赛会用)
    };
*/

/* 公共结构体 */
export interface RankItem {
  lUid: number,        // 主播uid
  iRank: number,       // 排名
  lScore: number,      // 分数
  sNickName: string,   // 昵称
  sLogoUrl: string,    // 头像
  tJump: JumpChannel,       // 跳转
  iArea?: number,       // 主播所属分组
}
export interface JumpChannel {
  lPid: number,       // 主播Uid
  lTid: number,       // 频道Tid
  lSid: number,       // 频道Sid
  iGameId: number,    // 品类id
  lYYId: number,      // YY
  iRoomId: number,    // roomid
  iLive: number,      // 是否在播
}

// 获取阶段
type GetStageReq = (
  option: {
    lPid: number,
    iActId: number,
  }
) => Promise<GetStageRsp>
export interface GetStageRsp {
  iStage: number, // 当前赛程
  iDay: number, // 当前赛程下第几天
  iArea: number,  // 参考@RankAreaURI
}
const getStage: GetStageReq = option => {
  if (staticClose) return tafFetch('getStage', option, ActGuildAllStar.GetStageReq, ActGuildAllStar.GetStageRsp);
  return new Promise(resolve => {
    resolve({
      iArea: 2,
      iDay: 2,
      iStage: 5,
    })
  })
}


// 获取PK场次
type GetPkStageReq = (
  option: {
    lPid: number,
    iActId: number,
    iStage: number,
  }
) => Promise<GetPkStageRsp>
export interface GetPkStageRsp {
  iStage: number, // 当前赛程
  iDay: number, // 当前赛程下第几天
  iTotalDay: number,  // 当前赛程总天数
  iArea: number, // 参考@RankAreaURI
  iRound: number,
  mRound2Hour: {
    value: any,
  }, // 场次对应小时
}
const getPkStage: GetPkStageReq = option => {
  if (staticClose) return tafFetch('getPkStage', option, ActGuildAllStar.GetPkStageReq, ActGuildAllStar.GetPkStageRsp);
  return new Promise(resolve => {
    // resolve({
    //   iStage: 1,
    //   iDay: 2,
    //   iArea: 1,
    //   iTotalDay: 2,
    //   iRound: 4,
    //   mRound2Hour: {
    //     value: {
    //       1: 14,
    //       2: 16,
    //       3: 18,
    //       4: 20,
    //       5: 22,
    //       6: 24,
    //     }
    //   }
    // })
    resolve(data.getPkStage['iStage' + option.iStage]);
  })
}


// 小时榜单
type GetHourRankReq = (
  option: {
    iStage: number,
  }
) => Promise<GetHourRankRsp>
export interface GetHourRankRsp {
  iCurStage: number,  // 当前赛程
  vGameRank: {        // 游戏主播小时榜
    value: RankItem[],
  },
  vEntertainmentRank: {   // 娱乐主播小时榜
    value: RankItem[],
  },
  vGameHourRank: {    // 游戏小时冠军
    value: HourTopItem[],
  },
  vEntertainmentHourRank: {   // 娱乐小时冠军
    value: HourTopItem[],
  },
  tPidGameRank: RankItem, // 当前主播游戏小时榜排行
  tPidEntertainmentRank: RankItem,  // 当前主播娱乐小时榜排行
}
export interface HourTopItem {
  sNickName: string,
  sLogoUrl: string,
  sDesc: string,
  tJump: JumpChannel,
}
const getHourRank: GetHourRankReq = option => {
  if (staticClose) return tafFetch('getHourRank', option, ActGuildAllStar.GetHourRankReq, ActGuildAllStar.GetHourRankRsp);
  return new Promise(resolve => {
    // resolve({
    //   iCurStage: 2,
    //   vGameRank: {
    //     value: RankItemMock(0),
    //   },
    //   vEntertainmentRank: {
    //     value: RankItemMock(50),
    //   },
    //   vGameHourRank: {
    //     value: HourTopItemMock(10),
    //   },
    //   vEntertainmentHourRank: {
    //     value: HourTopItemMock(5),
    //   },
    //   tPidGameRank: RankItemMock(1)[0],
    //   tPidEntertainmentRank: RankItemMock(1)[0],
    // })
    resolve(data.getHourRank['iStage' + option.iStage])
  })
}

// 公会榜单
type GetGuildRankReq = (
  option: {
    iActId: number,
    iStage: number,
    iArea: number,
    iRevive: number,
  }
) => Promise<GetGuildRankRsp>
export interface GetGuildRankRsp {
  iCurStage: number,
  vRank: {    // 公会榜单
    value: GuildItem[],
  },
}
export interface GuildItem {
  lCompanyId: number,   // 公司id
  sCompanyName: string,   // 公司名
  sCompanyLogoUrl: string,    // 公司头像
  iRank: number,  // 公司排名
  lScore: number, // 公司分数
  sDesc: string, // 公会描述
  vRank: {        // 主播榜单
    value: RankItem[],
  }
}
const getGuildRank: GetGuildRankReq = option => {
  if (staticClose) return tafFetch('getGuildRankSp', option, ActGuildAllStar.GetGuildRankSpReq, ActGuildAllStar.GetGuildRankSpRsp);
  return new Promise(resolve => {
    // resolve({
    //   iCurStage: 2,
    //   vRank: {
    //     value: GuildItemMock(50),
    //   },
    // })
    if (option.iRevive === 1) {
      resolve(data.getGuildRank2['iArea' + option.iArea]);
    } else {
      if (option.iArea === 5) {
        resolve(data.getGuildRank['iStage' + option.iStage]);
      } else {
        resolve(data.getGuildRank1['iStage' + option.iStage]['iArea' + option.iArea]);
      }
    }
  })
}

// 公会详情
type GetGuildDetailReq = (
  option: {
    iStage: number,
    lCompanyId: number,   // 公司id	
    iArea: number,
  }
) => Promise<GetGuildDetailRsp>
export interface GetGuildDetailRsp {
  iCurStage: number,    // 当前赛程	
  sNickName: string,    // 公司名
  vRich: {              // 公会神豪榜
    value: RankItem[],
  },
  vContribution: {      // 当前阶段贡献
    value: RankItem[],
  },
  vContributionTotal: { // 总贡献
    value: RankItem[],
  },
}
const getGuildDetail: GetGuildDetailReq = option => {
  if (staticClose) return tafFetch('getGuildDetail', option, ActGuildAllStar.GetGuildDetailReq, ActGuildAllStar.GetGuildDetailRsp);
  return new Promise(resolve => {
    // resolve({
    //   iCurStage: 2,
    //   sNickName: 'mock名字mock名字mock名字mock名字mock名字',
    //   vRich: {
    //     value: RankItemMock(50),
    //   },
    //   vContribution: {
    //     value: RankItemMock(50),
    //   },
    //   vContributionTotal: {
    //     value: RankItemMock(50),
    //   },
    // })
    // if (option.iRevive === 1) {
    //   resolve(data.getGuildRank2['iArea' + option.iArea]);
    // } else {
    //   if (option.iArea === 5) {
    //     resolve(data.getGuildRank['iStage' + option.iStage]);
    //   } else {
    //     resolve(data.getGuildRank1['iStage' + option.iStage]['iArea' + option.iArea]);
    //   }
    // }
  })
}

// 公会对决
type GetGuildPkDetailReq = (
  option: {
    iStage: number,
    iDay: number,
    iRound: number, // 轮次
    iArea: number,
    iRevive: number,
  }
) => Promise<GetGuildPkDetailRsp>
export interface GetGuildPkDetailRsp {
  iCurStage: number,
  iDay: number,
  iRound: number,
  vRank: {
    value: GuildPkRoundItem[],  // 对阵
  }
}
export interface GuildPkRoundItem {
  sAttGuildName: string,  // 攻击方公会名	
  sAttGuildLogo: string,  // 攻击方公会头像
  sDefGuildName: string,  // 防守方公会名	
  sDefGuildLogo: string,  // 防守方公会头像
  iAttWin: number,  // 攻击方大比分
  iDefWin: number,  // 防守方大比分
  vMatch: {
    value: GuildPkMatchItem[],  // 比赛轮次 
  }
}
export interface GuildPkMatchItem {
  tAttSide: RankItem,	  // 攻击方主播
  tDefSide: RankItem,		// 防守方主播
  iMatch: number,       // 比赛场次	
  iResult: number,      // 比赛结果，0：未定，1：攻击方赢，2：防守方赢
  sDesc: string,        // 文本内容有如下：已结束，进行中，xx:xx开始
  iStatus: number,      // PK进度，0：未开始，1：PK中，2：已结束
}
// 废弃
// export interface RivalPanel {
//   vRank: {
//     value: RivalItem[],
//   },
//   iArea: number,
//   lUnionId: number,
//   sUnionName: string,
//   sRivalUnionName: string,
//   iScore: number,
//   iRivalScore: number,
//   lWinScore: number,
//   lMaxScore: number,
// }
// export interface RivalItem {
//   tLeft: AnchorItem,
//   tRight: AnchorItem,
//   iPkState: number,
//   lBeginTime: number,
// }
// export interface AnchorItem {
//   lUid: number,
//   sNickName: string,
//   sLogoUrl: string,
//   tJump: JumpChannel,
//   iResult: number,
// }
const getGuildPkDetail: GetGuildPkDetailReq = option => {
  if (staticClose) return tafFetch('getGuildPkDetail', option, ActGuildAllStar.GetGuildPkDetailReq, ActGuildAllStar.GetGuildPkDetailRsp);
  return new Promise(resolve => {
    // resolve({
    //   iCurStage: 2,
    //   iDay: 1,
    //   iRound: 1,
    //   vRank: {
    //     value: GuildPkRoundItemMock(30),
    //   }
    // })
    if (option.iRevive === 1) {
      resolve(data.getGuildPkDetail1['iArea' + option.iArea]['iDay' + option.iDay]['iRound' + option.iRound])
    } else {
      if (option.iArea === 5) {
        resolve(data.getGuildPkDetail2['iDay' + option.iDay]['iRound' + option.iRound])
      } else {
        resolve(data.getGuildPkDetail['iStage' + option.iStage]['iArea' + option.iArea]['iDay' + option.iDay]['iRound' + option.iRound])
      }
    }
  })
}

// 神豪榜
type richReq = (
  option: {}
) => Promise<GetRichRankRsp>
export interface GetRichRankRsp {
  vRank: {
    value: RankItem[],
  },
}
const getRichRank: richReq = option => {
  if (staticClose) return tafFetch('getRichRank', option, ActGuildAllStar.GetGuildDetailReq, ActGuildAllStar.GetRichRankRsp);
  return new Promise(resolve => {
    // resolve({
    //   vRank: {
    //     value: RankItemMock(50),
    //   },
    // })
    resolve(data.getRichRank)
  })
}

const fetch = {
  getStage,
  getPkStage,
  getHourRank,
  getGuildRank,
  getGuildDetail,
  getRichRank,
  getGuildPkDetail,
}
export {
  fetch,
  RankItemMock,
}
